import React  from 'react';
import styled from 'styled-components';
import { TextBtn2 } from '../Inputs/TextBtn2';
import { Link, useParams } from 'react-router-dom';
const Styles = styled.div`
  width: 100%;
  height: 22vw;
  overflow: hidden;
  position: relative;
  &.ltr {
    .data {
      inset: 1rem 50% 1rem var(--universal-pad);
    }
  }
  &.type-2 {
    .data {
      color: var(--prime-dark);
    }
    @media screen and (max-width: 850px) {
      .data {
        inset: 1.5rem calc(var(--universal-pad) + 10px) 4rem calc(var(--universal-pad) + 10px);
        align-items: center;
      }
    }
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .drop {
    position: absolute;
    inset: 0;
    background-color: #00000040;
  }
  .data {
    position: absolute;
    inset: 1rem var(--universal-pad) 1rem 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #fff;
    gap: 0.7rem;
    .title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .desc {
      font-size: 0.8rem;
      font-weight: 500;
    }
    .btns {
      display: flex;
      gap: 0.5rem;
      width: 80%;
      flex-wrap: wrap;
      margin: 0.5rem 0;
      .btn {
        text-decoration: none;
        color: inherit;
        flex-grow: 1;
        cursor: pointer;
        min-width: calc(50% - 3rem);
        padding: calc(var(--fs-textfield) / 2) 1rem;
        border: none;
        outline: none;
        transition: var(--trans-1);
        font-size: var(--fs-textfield);
        fill: var(--n-grey-0);
        display: flex;
        justify-content: center;
        gap: 0.3rem;
        align-items: center;
        white-space: nowrap;
        min-height: 28px;
        background-color: var(--main-color);
        color: var(--n-grey-0);
        border: 1px solid var(--main-color);
        border-radius: var(--border-radius-3);
        &:hover {
          color: var(--n-grey-0);
          border: 1px solid var(--n-grey-0);
          background-color: var(--secn-color);
        }
      }
    }
  }
  @media screen and (max-width: 850px) {
    height: 100vw;
    &.ltr {
      .data {
        inset: 2.5rem calc(var(--universal-pad) + 10px) 4rem calc(var(--universal-pad) + 10px);
      }
    }
    .data {
      inset: 2.5rem calc(var(--universal-pad) + 10px) 4rem calc(var(--universal-pad) + 10px);
      justify-content: flex-start;
      .btns {
        align-self: center;
        width: 100%;
      }
    }
  }
`
export default function HeaderWithTitle20 (props){
  const {data: dataRaw, lan, dataMain} = props;
  const data = JSON.parse(dataRaw);
  const params = useParams()

  let image = data.ImageDesktop;
  if(window.innerWidth < 850){
    image = data.ImageMobile;
  }
  const makeBtns = (data) => {
    if(!data.btns){
      return;
    }
    return data.btns.map((v, i) => {
      return (
        <Link to={"/" + lan.filename + v.link} className='btn' key={i}>
          {v.text}
        </Link>
      )
    })
  }
  let title = data.title;
  if(title === '${auto}'){
    if(dataMain.Country && dataMain.Country.Country_Url === params.country){
      title = lan.filename === "fa" ? "تور " + dataMain.Country.Country_Name : dataMain.Country.Country_En_Name + " Tour"
    }
  }
  let className = "";
  if(data.model && data.model === "2"){
    className = "type-2"
  }

  return (
    <Styles className={lan.dir + " " + className}>
      <img src={image} alt='background'/>
      {/* <div className='drop'></div> */}
      <div className='data'>
        <h1 className='title'>
          {title}
        </h1>
        <div className='desc'>
          {data.desc}
        </div>
        <div className='btns'>
          {makeBtns(data)}
        </div>
      </div>
    </Styles>
  )
}

